// export const apiUrl = 'http://localhost:4000';

export const apiUrl = process.env.REACT_APP_BACKEND;

// export const apiUrl = "http://54.210.75.161:4000";
// export const apiUrl = "http://3.85.250.140/api";